/**
 * Section glue for Atlas slider flipbook.
 * Depends on: Swiper, AtlasPdfFlipbook
 */
(function () {
  'use strict';

  function readNumber(el, attr, fallback) {
    var value = parseFloat(el.getAttribute(attr));
    return Number.isFinite(value) ? value : fallback;
  }

  function toFilename(title) {
    var name = (title || 'catalogue')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return (name || 'catalogue') + '.pdf';
  }

  function forceDownload(url, filename) {
    return fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename || 'catalogue.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function () {
          URL.revokeObjectURL(objectUrl);
        }, 1000);
      });
  }

  if (!window.AtlasFlipbookSlider) {
    window.AtlasFlipbookSlider = {
      init: function (root) {
        if (!root) return;
        this.initModal(root);
        this.initSwiper(root);
      },

      initSwiper: function (root) {
        if (!window.Swiper) return;

        var el = root.querySelector('[data-asf-swiper]');
        var prevEl = root.querySelector('[data-asf-prev]');
        var nextEl = root.querySelector('[data-asf-next]');
        var navEl = root.querySelector('[data-asf-nav]');
        if (!el) return;

        if (root._swiper) {
          root._swiper.destroy(true, true);
          root._swiper = null;
        }

        root._swiper = new Swiper(el, {
          slidesPerView: readNumber(el, 'data-slides-mobile', 1.15),
          spaceBetween: readNumber(el, 'data-space-mobile', 12),
          speed: 450,
          watchOverflow: true,
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
          breakpoints: {
            750: {
              slidesPerView: readNumber(el, 'data-slides-desktop', 4),
              spaceBetween: readNumber(el, 'data-space-desktop', 16),
            },
          },
          on: {
            init: function (swiper) {
              if (navEl) navEl.classList.toggle('is-hidden', swiper.isLocked);
            },
            resize: function (swiper) {
              if (navEl) navEl.classList.toggle('is-hidden', swiper.isLocked);
            },
            update: function (swiper) {
              if (navEl) navEl.classList.toggle('is-hidden', swiper.isLocked);
            },
          },
        });
      },

      initModal: function (root) {
        if (root.dataset.asfModalInit === 'true') return;
        if (!window.AtlasPdfFlipbook) return;

        var modal = root.querySelector('[data-asf-modal]');
        var flipRoot = modal && modal.querySelector('[data-atlas-pdf-flipbook]');
        if (!modal || !flipRoot) return;

        root.dataset.asfModalInit = 'true';

        var titleEl = modal.querySelector('[data-asf-modal-title-el]');
        var downloadEl = modal.querySelector('[data-asf-download]');
        var flipbook = AtlasPdfFlipbook.mount(flipRoot, {
          emptyMessage: 'Add a PDF URL to this catalogue block.',
        });
        var boundKeydown = null;
        var activePdf = '';
        var activeFilename = 'catalogue.pdf';
        var lastTrigger = null;

        function openModal(trigger) {
          var title = trigger.getAttribute('data-asf-modal-title') || '';
          var pdf = trigger.getAttribute('data-asf-pdf') || '';
          lastTrigger = trigger;

          if (titleEl) titleEl.textContent = title;
          activePdf = pdf;
          activeFilename = toFilename(title);

          if (downloadEl) {
            if (pdf) {
              downloadEl.href = pdf;
              downloadEl.classList.remove('is-disabled');
            } else {
              downloadEl.href = '#';
              downloadEl.classList.add('is-disabled');
            }
          }

          if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }

          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          flipbook.enableKeys();

          boundKeydown = function (event) {
            if (event.key === 'Escape') closeModal();
          };
          document.addEventListener('keydown', boundKeydown);

          var closeBtn = modal.querySelector('.atlas-flipbook-modal__close');
          if (closeBtn) closeBtn.focus();

          // Wait for modal layout so PageFlip gets real dimensions.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (pdf) {
                flipbook.load(pdf);
              } else {
                flipbook.showEmpty('Add a PDF URL to this catalogue block.');
              }
            });
          });
        }

        function closeModal() {
          var focused = modal.querySelector(':focus');
          if (focused && typeof focused.blur === 'function') focused.blur();

          flipbook.destroy();
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';

          if (boundKeydown) {
            document.removeEventListener('keydown', boundKeydown);
            boundKeydown = null;
          }

          if (lastTrigger && typeof lastTrigger.focus === 'function') {
            lastTrigger.focus();
          }
          lastTrigger = null;
        }

        root.querySelectorAll('[data-asf-open]').forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            openModal(trigger);
          });
        });

        if (downloadEl) {
          downloadEl.addEventListener('click', function (event) {
            if (!activePdf || downloadEl.classList.contains('is-disabled')) {
              event.preventDefault();
              return;
            }

            event.preventDefault();
            forceDownload(activePdf, activeFilename).catch(function () {
              window.open(activePdf, '_blank', 'noopener');
            });
          });
        }

        modal.querySelectorAll('[data-asf-close]').forEach(function (btn) {
          btn.addEventListener('click', closeModal);
        });
      },

      initIn: function (scope) {
        (scope || document).querySelectorAll('[data-atlas-flipbook]').forEach(function (node) {
          window.AtlasFlipbookSlider.init(node);
        });
      },
    };

    function bootAll() {
      if (!window.Swiper || !window.AtlasPdfFlipbook) {
        setTimeout(bootAll, 50);
        return;
      }
      window.AtlasFlipbookSlider.initIn(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      window.AtlasFlipbookSlider.initIn(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      var orphan = document.getElementById('AtlasFlipbookModal--' + sectionId);
      if (orphan) orphan.remove();
    });
  }
})();
